/**
 *
 * AdjustmentReports
 *
 */
import * as React from 'react';
import { Route, Routes } from 'react-router-dom';
import { AdjustmentReport } from './AdjustmentReport';
import { AdjustmentReports as AR } from './AdjustmentReports';
import { AdjustmentReportStatus } from './slice/types';

interface Props {
  status?: AdjustmentReportStatus;
}

export function AdjustmentReports(props: Props) {
  const { status = 'amended-items' } = props;
  return (
    <Routes>
      <Route path={''} element={<AR {...props} />} />
      <Route path={`:id`} element={<AdjustmentReport />} />
    </Routes>
  );
}
